import { Injectable, Inject } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FlagService {
  constructor(@Inject('ServiceByType') private ServiceByType: any) {}

  flag(type: string, id: number, reason: string): Promise<any> {
    return this.ServiceByType.get(type).flag(id, reason);
  }
}
